export const NEW_BOOKING = 'NEW_BOOKING'